// src/components/matchInput/PlayerRatingsStep.js
import React from "react";
import Dropdown from "../central/Dropdown";

const POSITIONS = ["DEF", "MID", "FWD"];
const RATINGS = [1, 2, 3, 4, 5];

// Pricing rules
const DEFAULT_PRICES = { DEF: 5.0, MID: 5.5, FWD: 6.0 };
const RATING_ADJ = { 1: -1.0, 2: -0.5, 3: 0.0, 4: 0.5, 5: 1.0 };

const computePrice = (pos, rating) =>
  Number(((DEFAULT_PRICES[pos] ?? 0) + (RATING_ADJ[rating] ?? 0)).toFixed(1));

export default function PlayerRatingsStep({ players, setPlayers }) {
  const updatePlayer = (id, updates) => {
    setPlayers((prev) =>
      prev.map((player) => {
        if (player.id !== id) return player;

        const updated = { ...player, ...updates };
        if (updated.position && updated.rating) {
          updated.price = computePrice(updated.position, updated.rating);
        }
        return updated;
      })
    );
  };

  const setAllRatingsToDefault = () => {
    setPlayers((prev) =>
      prev.map((player) => ({
        ...player,
        rating: 3,
        price: computePrice(player.position || "MID", 3),
      }))
    );
  };

  const dropdownStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    container: (base) => ({ ...base, width: "100%", minWidth: 0, boxSizing: "border-box" }),
    control: (base) => ({
      ...base,
      minWidth: 0,
      width: "100%",
      boxSizing: "border-box",
    }),
    valueContainer: (base) => ({ ...base, minWidth: 0, boxSizing: "border-box" }),
    indicatorsContainer: (base) => ({ ...base, boxSizing: "border-box" }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
  };

  const dropdownContainerStyle = {
    width: "100%",
    marginRight: 0,
    display: "block",
  };

  return (
    <div style={{ maxWidth: 680 }}>
      <div style={{ fontSize: 13, color: "#666", marginBottom: 10 }}>
        Assign each player a position and a rating from 1–5. <br/>
        Ratings influence the player's starting price for the league.
      </div>

      <div style={{ marginBottom: 12 }}>
        <button
          type="button"
          onClick={setAllRatingsToDefault}
          style={{
            border: "1px solid #ddd",
            background: "#fff",
            borderRadius: 8,
            padding: "8px 12px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Set all ratings to 3
        </button>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
      {players.map((player) => (
        <div
          key={player.id}
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center",
            justifyContent: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              fontWeight: 600,
              flex: "0 1 clamp(70px, 30vw, 120px)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {player.name}
          </div>

          {/* Position Dropdown */}
          <div style={{ flex: "0 1 clamp(80px, 26vw, 86px)" }}>
            <Dropdown
              value={player.position || "MID"}
              onChange={(val) =>
                updatePlayer(player.id, { position: val })
              }
              options={POSITIONS.map((pos) => ({
                value: pos,
                label: pos,
              }))}
              menuPortalTarget={document.body}
              styles={dropdownStyles}
              containerStyle={dropdownContainerStyle}
            />
          </div>

          {/* Rating Dropdown */}
          <div style={{ flex: "0 1 clamp(70px, 26vw, 60px)" }}>
            <Dropdown
              value={player.rating || 3}
              onChange={(val) =>
                updatePlayer(player.id, { rating: Number(val) })
              }
              options={RATINGS.map((r) => ({
                value: r,
                label: String(r),
              }))}
              menuPortalTarget={document.body}
              styles={dropdownStyles}
              containerStyle={dropdownContainerStyle}
            />
          </div>
        </div>
      ))}
      </div>
    </div>
  );
}